export enum TyreStatusType {
  Fitted = 'fitted',
  New = 'new',
  Reusable = 'reusable',
  audit = 'audit',
  recycled = 'recycled',
  unknown = 'unkown'
}
